import Magnifier from "@/Icons/Magnifier";

import { useCallback, useState } from "react";

export type SearchProps = {
  placeholder: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export function Search({ placeholder, onChange }: SearchProps) {
  const [value, setValue] = useState("");

  const _onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setValue(e.target.value);
      onChange?.(e);
    },
    [onChange],
  );

  return (
    <div className="m-5 mb-0">
      <Magnifier
        className="text-grey6 absolute mt-2.5 ml-2"
        width={18}
        height={18}
      />
      <input
        type="text"
        value={value}
        onChange={_onChange}
        placeholder={placeholder}
        className="font-dm-sans h-8 h-[40px] min-w-[300px] border-black pl-8 text-sm leading-10"
        data-1p-ignore
      />
    </div>
  );
}
